export enum EmergencyContactRelationship {
  SPOUSE = 'Spouse',
  CHILD = 'Child',
  HEALTHCARE_PROVIDER = 'Healthcare provider',
  SIBLING = 'Sibling',
  FRIEND = 'Friend',
  PARTNER = 'Partner',
  CASE_WORKER = 'Case Worker',
  MANAGER = 'Manager',
  PARENT = 'Parent',
}
